import React, { useState, useRef, useEffect, useMemo } from "react";
import Header from "../../layouts/Header";
import { Tooltip, Progress, FloatButton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/styles/local/quoteNew.css";
import { DownloadQuotesPDF } from "../../redux/actions/proformaAction";
import arrow from "../../assets/icons/arrowdown.svg";
import NotShow from "../../assets/icons/Not show.svg";
import Show from "../../assets/icons/eye.svg";
import Plus from "../../assets/icons/Plus.svg";
import bin from "../../assets/icons/Bin - Copy.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import calender from "../../assets/images/Calendar3.svg";
import { IoMdCheckmark } from "react-icons/io";
import Modal from "react-bootstrap/Modal";
import close from "../../assets/icons/x-circle.svg";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html"; // if needed to covert editor in HTML format.
import { stateFromHTML } from "draft-js-import-html"; // if needed to covert editor in HTML format.
import {
  EditorState,
  Modifier,
  convertFromRaw,
  convertToRaw,
  RichUtils,
  getDefaultKeyBinding,
} from "draft-js";
import BoldIcon from "../../assets/icons/Bold2.svg";
import ItalicIcon from "../../assets/icons/italic2.svg";
import UnderlineIcon from "../../assets/icons/underline2.svg";
import unorderedList from "../../assets/icons/Contacts10.svg";
import "draft-js/dist/Draft.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { BsBoxSeam } from "react-icons/bs";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import simpleRequest from "../../utils/helpers/simpleRequest";
import {
  quoteProductState,
  emptyAddQuoteState,
  QuotesGeneratePDF,
  UpdateSectionIsDefault,
} from "../../redux/actions/action";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const QuoteNew = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { quoteId } = useParams();

  const HIGH = process.env.REACT_APP_TASK_PRIORITY_HIGH;
  const MEDIUM = process.env.REACT_APP_TASK_PRIORITY_NORMAL;
  const LOW = process.env.REACT_APP_TASK_PRIORITY_LOW;
  const popupRef = useRef(null);
  const heightRef = useRef(null);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Quotes").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  // const statusList = ["Draft", "Lost", "Sent", "Approved"];
  const statusList = [t("Draft"), t("Lost"), t("Sent"), t("Approved")];

  const [activeDrop, setActiveDrop] = useState(false);
  const [activeTab, setActiveTab] = useState("General");
  const [showSections, setShowSections] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [subSectionName, setSubSectionName] = useState("");
  const [allSectionsHeight, setAllSectionsHeight] = useState(0);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [sections, setSections] = useState([]);
  const [quoteDetails, setQuoteDetails] = useState({
    quoteCode: "",
    status: "",
    projectName: "",
    projectCode: "",
    projectId: "",
    quoteDate: "",
    mainContact: "",
    reference: "",
    priorityId: HIGH,
  });
  const dropId = "123456";

  const { quoteProducts } = useSelector((state) => state.user);

  const activeSection = useMemo(
    () => sections?.find((item) => item?.sectionName === activeTab),
    [sections, activeTab],
  );

  const sectionIndex = useMemo(
    () => sections?.findIndex((item) => item?.sectionName === activeTab),
    [activeTab, quoteDetails],
  );

  const onDragEnd = (result) => {
    if (!result.destination) return;
    let list = [...sections[sectionIndex].subSections];
    const [reorderedItem] = list.splice(result.source.index, 1);
    list.splice(result.destination.index, 0, reorderedItem);

    // Update indexPosition for all items
    list.forEach((item, index) => {
      item.indexPosition = index + 1;
    });

    sections[sectionIndex]["subSections"] = list;
    setSections([...sections]);
  };

  const handleAddSection = () => {
    if (!subSectionName) return;
    let sectionsList = [...sections];
    let section = activeSection || {
      sectionName: activeTab,
    };
    let list = section?.subSections || [];
    list?.push({
      sectionName: activeTab,
      title: subSectionName,
      description: EditorState.createEmpty(),
      subSectionParts: [],
      indexPosition: list?.length + 1,
    });
    section["subSections"] = list;
    if (sectionIndex !== -1) sectionsList.splice(sectionIndex, 1, section);
    else sectionsList.push(section);
    setSections([...sectionsList]);
    setSubSectionName("");
    setShowPopup(false);
  };

  const handleSave = async (type = "") => {
    setChangeComp("");
    const sectionsList = [...sections];
    let list = [];
    sectionsList?.map((section) => {
      let subSections = [];
      let totalAmount = 0;

      section.subSections?.map((subSection) => {
        let sub = {
          ...subSection,
          description: stateToHTML(
            subSection?.description?.getCurrentContent(),
          ),
        };
        delete sub["sectionName"];
        subSections.push(sub);
        totalAmount += subSection.total || 0;
      });

      let newSection = { ...section, subSections, totalAmount };
      list.push(newSection);
    });

    const payload = {
      maincontact: quoteDetails?.mainContact,
      priorityid: quoteDetails?.priorityId,
      projectcode: quoteDetails?.projectCode,
      projectid: quoteDetails?.projectId,
      sections: list,
      quoteid: quoteId,
      reference: quoteDetails?.reference,
      quoteDate: quoteDetails?.quoteDate,
      quotecode: quoteDetails?.quoteCode,
      // total: list.length > 0 ? list[0].totalAmount : 0,
      total: list.find((x) => x.sectionName === "General")?.totalAmount || 0,
      // total: list.reduce((sum, section) => sum + (section.totalAmount || 0), 0),
      status: quoteDetails?.status,
    };
    const resp = await simpleRequest(`/api/quote/${quoteId}`, "post", payload);
    if (resp?.status === true && type !== "print") history.goBack();
  };

  const fetchQuote = async () => {
    const resp = await simpleRequest(`/api/quote/${quoteId}`, "get", {});
    if (resp?.status === true) {
      const { data } = resp;
      setQuoteDetails({
        quoteCode: data?.quotecode,
        status: data?.status,
        quoteDate: new Date(data?.quoteDate || new Date()),
        projectCode: data?.projectcode,
        projectId: data?.projectid,
        projectName: data?.projectname,
        mainContact: data?.maincontact,
        reference: data?.reference,
        priorityId: data?.priorityid,
      });
      if (quoteProducts?.action === "add") {
        setSections(quoteProducts.sections);
        setActiveTab(quoteProducts?.activeTab);
        setQuoteDetails({ ...quoteProducts?.quoteDetails });
        dispatch(quoteProductState({}));
      } else {
        const sectionsList = [...data?.sections];
        let list = [];
        sectionsList?.map((section) => {
          let subSections = [];
          section?.subSections?.map((subSection) => {
            let sub = {
              ...subSection,
              // description: EditorState.createWithContent(
              //   convertFromRaw(JSON.parse(subSection?.description))
              // ),
              description: EditorState.createWithContent(
                stateFromHTML(subSection?.description),
              ),
            };
            subSections.push(sub);
          });
          list.push({ ...section, subSections });
        });
        setSections([...list]);
      }
    }
  };

  const handlePrint = () => {
    handleSave("print");
    setShowPrintModal(true);
  };

  useEffect(() => {
    setAllSectionsHeight(heightRef.current.clientHeight);
  });

  useEffect(() => {
    fetchQuote();
  }, []);

  useEffect(() => {
    dispatch(emptyAddQuoteState());
  }, []);

  // Print popup start.
  const [closePopup, setClosePopup] = useState(false);
  const [printPopupShow, setPrintPopupShow] = useState(false);
  const [quoteTemplatesPDFData, setQuoteTemplatesPDFData] = useState([]);

  const quoteGenratePDFResponse = useSelector(
    (state) => state.user.quoteGenratePDFResponse,
  );

  useEffect(() => {
    if (quoteGenratePDFResponse.status === true) {
      setQuoteTemplatesPDFData(quoteGenratePDFResponse?.data);
    }
  }, [quoteGenratePDFResponse]);
  const link = window.sessionStorage.getItem("quoteLink");

  const downloadQuotePdfFunction = () => {
    DownloadQuotesPDF(quoteId).then(
      (result) => {
        console.log(result);
      },
      (error) => {
        console.error(error);
      },
    );
  };

  const handlePrintPopup = (item, printoption, templateid) => {
    if (printoption === "PRINT_USING_TEMPLATE") {
      dispatch(QuotesGeneratePDF(quoteId, templateid));
      setPrintPopupShow(false);
    }
    if (printoption === "CREATE_PDF") {
      // downloadQuotePdfFunction(); // if we want downlod pdf.
      history.push(`/quote/${quoteId}/pdf`);
    }
    if (printoption === "Create_Online_version") {
      const win = window.open(link, "_blank");
      win.focus();
    }
    setTimeout(() => {
      setClosePopup(true);
    }, 3000);
  };
  // Print popup start.

  const [changeComp, setChangeComp] = useState("");
  const [canGoBack, setCanGoBack] = useState(false);
  const [defaultActive, setDefaultActive] = useState(false);
  useEffect(() => {
    setDefaultActive(activeSection?.subSections?.[0]?.isDefault === 1);
  }, [activeSection]);

  return (
    <>
      <Header />
      <RouteLeavingGuard
        when={changeComp !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          const path = location.pathname;
          if (path.includes("/product-and-service")) {
            return false;
          }
          // This case it blocks the navigation when:
          // 1. the login form is dirty, and
          // 2. the user is going to 'sign-up' scene.
          //    (Just an example, in real case you might
          //     need to block all location regarding this case)
          if (changeComp !== "") {
            if (![`/quote/${quoteId}`].includes(location.pathname)) {
              if (location.pathname === "/contact-list" && !canGoBack) {
                return true;
              } else if (location.pathname === "/contact-list" && canGoBack)
                return false;
              localStorage.removeItem("quoteBlockNavigation");
              return true;
            }
          }
          return false;
        }}
      />

      <PrintModal
        showPrintModal={showPrintModal}
        setShowPrintModal={setShowPrintModal}
        setChangeComp={setChangeComp}
        FetchTranslationList={FetchTranslationList}
      />

      <div className="quote-n-id-box">
        <div className="quote-n-topbox frcb" style={{ alignItems: "start" }}>
          <div
            className="frc flex-wrap"
            style={{ gap: "1rem", alignItems: "start" }}
          >
            <div className="quote-n-top-id-box frcb">
              <p className="mb-0">
                {/* Quote */}
                {t("Quote")}
              </p>
              <p className="mb-0">
                {/* ID */}
                {t("ID")}
                {quoteDetails?.quoteCode}
              </p>
            </div>
            <div
              className="quote-n-drop-main fc"
              style={{
                border: activeDrop ? "1px solid #A5A5A5" : "",
                position: "relative",
              }}
            >
              <div
                className="quote-n-top-drop-box frcb"
                onClick={() => setActiveDrop(!activeDrop)}
              >
                <p className="mb-0">{quoteDetails?.status}</p>
                <img
                  src={arrow}
                  style={{
                    rotate: activeDrop ? "180deg" : "0deg",
                    transitionDuration: "300ms",
                  }}
                />
              </div>
              {activeDrop && (
                <div className="quote-n-drop">
                  {statusList?.map((status, index) => (
                    <div
                      className="frcb quote-n-top-drop-box"
                      style={{
                        backgroundColor:
                          status === quoteDetails?.status && "#fafafa",
                      }}
                      onClick={() => {
                        setQuoteDetails((quote) => ({ ...quote, status }));
                        setActiveDrop(false);
                      }}
                      key={index}
                    >
                      <p className="mb-0">{status}</p>
                      {status === quoteDetails?.status && (
                        <IoMdCheckmark style={{ color: "#333333" }} />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="frcb cancel" style={{ gap: "1rem" }}>
            <button
              className="cal-page-cancel"
              onClick={() => history.goBack()}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              className="cal-page-change"
              style={{ backgroundColor: "#00246A" }}
              onClick={handleSave}
            >
              {/* Save */}
              {t("Save")}
            </button>
          </div>
        </div>
        <div className="quote-n-box-2">
          <div className="frcb quote-n-box-tab-prob">
            <div style={{ overflow: "auto", width: "100%" }}>
              <div
                className="frc"
                style={{ columnGap: "1.5rem", minWidth: "500px" }}
              >
                <div
                  className={`fc single-box ${
                    activeTab === "General" && "active"
                  }`}
                  onClick={() => setActiveTab("General")}
                >
                  {/* General */}
                  {t("General   ")}
                </div>
                <div
                  className={`fc single-box ${
                    activeTab === "Other Conditions" && "active"
                  }`}
                  onClick={() => setActiveTab("Other Conditions")}
                >
                  {/* Other <br /> Conditions */}
                  {t("Other Conditions  ").slice(0, 6)}
                  <br />
                  {t("Other Conditions  ").slice(6)}
                </div>
                <div
                  className={`fc single-box ${
                    activeTab === "Points of attention" && "active"
                  }`}
                  onClick={() => setActiveTab("Points of attention")}
                >
                  {/* Points of <br /> attention */}
                  {t("Points of  attention").slice(0, 9)}
                  <br />
                  {t("Points of  attention").slice(9)}
                </div>
                <div
                  className={`fc single-box ${
                    activeTab === "Term & Condition" && "active"
                  }`}
                  onClick={() => setActiveTab("Term & Condition")}
                >
                  {/* Appendix */}
                  {t("Term & Condition")}
                </div>
              </div>
            </div>
            <div
              className="st-single-stage-div"
              style={{ maxWidth: "320px", width: "100%" }}
            >
              <label
                className="st-single-stage-label"
                style={{ backgroundColor: "#fafafa" }}
              >
                {/* Assignment Probability */}
                {t("Assignment Probability")}
              </label>
              <div className="assign-prob-grid">
                <div className="frc" style={{ columnGap: "8px" }}>
                  <div
                    className="assign-prob-radio-btn"
                    onClick={() =>
                      setQuoteDetails((det) => ({
                        ...det,
                        priorityId: HIGH,
                      }))
                    }
                    style={{
                      background:
                        quoteDetails?.priorityId === HIGH
                          ? "linear-gradient(179deg, #00246A, #95A7C6)"
                          : "white",
                      border:
                        quoteDetails?.priorityId === HIGH
                          ? ""
                          : "0.5px solid #00000026",
                    }}
                  ></div>
                  <div className="assign-prob-radio-text">
                    {/* High */}
                    {t("High")}
                  </div>
                </div>
                <div className="frc" style={{ columnGap: "8px" }}>
                  <div
                    className="assign-prob-radio-btn"
                    onClick={() =>
                      setQuoteDetails((det) => ({
                        ...det,
                        priorityId: MEDIUM,
                      }))
                    }
                    style={{
                      background:
                        quoteDetails?.priorityId === MEDIUM
                          ? "linear-gradient(179deg, #00246A, #95A7C6)"
                          : "white",
                      border:
                        quoteDetails?.priorityId === MEDIUM
                          ? ""
                          : "0.5px solid #00000026",
                    }}
                  ></div>
                  <div className="assign-prob-radio-text">
                    {/* Medium */}
                    {t("Medium")}
                  </div>
                </div>
                <div className="frc" style={{ columnGap: "8px" }}>
                  <div
                    className="assign-prob-radio-btn"
                    onClick={() =>
                      setQuoteDetails((det) => ({ ...det, priorityId: LOW }))
                    }
                    style={{
                      background:
                        quoteDetails?.priorityId === LOW
                          ? "linear-gradient(179deg, #00246A, #95A7C6)"
                          : "white",
                      border:
                        quoteDetails?.priorityId === LOW
                          ? ""
                          : "0.5px solid #00000026",
                    }}
                  ></div>
                  <div className="assign-prob-radio-text">
                    {/* Low */}
                    {t("Low")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ overflow: "auto" }}>
            <div style={{ minWidth: "1150px", minHeight: "30rem" }}>
              <div
                className="all-sections-div quote-n-big-box"
                style={{ marginTop: "0" }}
              >
                <section className="all-sections-1">
                  <article className="all-sections-eye">
                    <img
                      src={showSections ? NotShow : Show}
                      onClick={() => setShowSections(!showSections)}
                    />
                    <p className="mb-0">
                      {/* Sections */}
                      {t("Sections")}
                    </p>
                  </article>
                  <article className="all-sections-eye-2">
                    {activeTab !== "Term & Condition" ? (
                      <article
                        className="frc"
                        style={{
                          columnGap: "1rem",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPopup(true)}
                      >
                        <img src={Plus} />
                        <p className="mb-0">
                          {/* Add New */}
                          {t("Add New")}
                        </p>
                      </article>
                    ) : (
                      <div className="d-flex align-items-center gap-2">
                        <label htmlFor="asc_purch_Switch" className="">
                          {/* Default */}
                          {t("Default")}
                        </label>
                        <input
                          type="checkbox"
                          id="asc_purch_Switch"
                          className="asc_pursh_Checkbox"
                          disabled={activeSection?.subSections?.[0]?.isDefault}
                          checked={defaultActive}
                          onChange={(e) => {
                            setDefaultActive(!defaultActive);
                            console.log("asc67", activeSection);
                            dispatch(
                              UpdateSectionIsDefault({
                                subsectionid:
                                  activeSection?.subSections?.[0]?.subsectionid,
                              }),
                            );
                          }}
                        />
                        <label
                          htmlFor="asc_purch_Switch"
                          className="asc_purch_Toggle"
                        >
                          {/* <p className=''>ASC</p> */}
                        </label>
                      </div>
                    )}

                    <article
                      className="add-sec-popup"
                      ref={popupRef}
                      style={{
                        transform: showPopup ? "scale(1)" : "scale(0)",
                        transitionDuration: "300ms",
                      }}
                    >
                      <p className="new-section-text">
                        {/* New Section */}
                        {t("New Section")}
                      </p>
                      <article className="add-sec-article">
                        <input
                          className="add-sec-input"
                          value={subSectionName}
                          onChange={(e) => {
                            setSubSectionName(e.target.value);
                            setChangeComp("asc");
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleAddSection();
                            }
                          }}
                        />
                        <article className="add-sec-under"></article>
                        <p className="add-sec-name">
                          {/* Name */}
                          {t("Name")}
                        </p>
                      </article>
                      <article className="add-sec-buttons">
                        <button
                          className="cancel-btn3"
                          onClick={() => {
                            setSubSectionName("");
                            setShowPopup(false);
                          }}
                        >
                          {/* Cancel */}
                          {t("Cancel")}
                        </button>
                        <button className="add-btn" onClick={handleAddSection}>
                          {/* Add */}
                          {t("Add")}
                        </button>
                      </article>
                    </article>
                  </article>
                </section>
                <div
                  style={{
                    height: `${allSectionsHeight}px`,
                    transitionDuration: "300ms",
                  }}
                >
                  <div
                    className="all-sections-grid"
                    ref={heightRef}
                    style={{ display: showSections ? "none" : "grid" }}
                  >
                    {activeSection?.subSections?.map((subSection, index) => {
                      return (
                        <p
                          className="all-sections-name ellipse"
                          key={`${index}-${subSection?.sectionid}`}
                          style={{ cursor: "pointer" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {(+index + 1)?.toString().padStart(2, "0")}
                          </span>{" "}
                          - {subSection?.title}
                        </p>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="quote-n-sections-main">
                {activeTab === "General" && (
                  <div className="quote-n-sections-main-1">
                    <div className="st-single-stage-div">
                      <p className="st-single-stage-label">
                        {/* Date */}
                        {t("Date")}
                      </p>
                      <section className="frc" style={{ columnGap: "8px" }}>
                        <img
                          alt=""
                          src={calender}
                          onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                        />
                        <AppDatePicker
                          open={isCalendarOpen}
                          onOpenChange={(open) => setIsCalendarOpen(open)}
                          selected={quoteDetails?.quoteDate}
                          onChange={(v) => {
                            setQuoteDetails((quote) => ({
                              ...quote,
                              quoteDate: v,
                            }));
                            setIsCalendarOpen(!isCalendarOpen);
                            setChangeComp("asc");
                          }}
                          dateFormat="dd/MM/yyyy"
                        />
                      </section>
                    </div>
                    <div className="st-single-stage-div">
                      <label className="st-single-stage-label">
                        {/* Project */}
                        {t("Project")}
                      </label>
                      <p className="quote-n-project-text">
                        {quoteDetails?.projectCode} |{" "}
                        {quoteDetails?.projectName}
                      </p>
                    </div>
                    <div className="st-single-stage-div">
                      <label className="st-single-stage-label">
                        {/* Main Contact */}
                        {t("Main Contact")}
                      </label>
                      <p className="quote-n-contact-text">
                        {quoteDetails?.mainContact}
                      </p>
                    </div>
                    <div className="st-single-stage-div">
                      <label className="st-single-stage-label">
                        {/* Reference */}
                        {t("Reference")}
                      </label>
                      <input
                        className="reference-input"
                        value={quoteDetails?.reference}
                        onChange={(e) => {
                          setChangeComp("asc");
                          setQuoteDetails((quote) => ({
                            ...quote,
                            reference: e.target.value,
                          }));
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="quote-n-sections-main-2">
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable
                      droppableId={dropId}
                      key={`droppable-${dropId}`}
                      direction="vertical"
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          key={`droppable-div-${dropId}`}
                          className="fc"
                          style={{ rowGap: "1rem", width: "100%" }}
                        >
                          {activeSection?.subSections?.map(
                            (subSection, index) => {
                              return (
                                <Draggable
                                  key={`draggable-${index}`}
                                  draggableId={`${index}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <SingleSubSection
                                      key={index}
                                      subSectionParts={
                                        subSection?.subSectionParts
                                      }
                                      sections={sections}
                                      setSections={setSections}
                                      index={index}
                                      activeTab={activeTab}
                                      subSection={subSection}
                                      provided={provided}
                                      quoteDetails={quoteDetails}
                                      setChangeComp={setChangeComp}
                                      changeComp={changeComp}
                                      FetchTranslationList={
                                        FetchTranslationList
                                      }
                                    />
                                  )}
                                </Draggable>
                              );
                            },
                          )}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const SingleSubSection = ({
  sections,
  setSections,
  index,
  activeTab,
  subSectionParts,
  subSection,
  provided,
  quoteDetails,
  setChangeComp,
  changeComp,
  FetchTranslationList,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { quoteId } = useParams();
  const t = (key) => FetchTranslationList?.[key] || "";

  const textEnd = { textAlign: "end" };

  const toolbar = {
    options: ["inline", "list"],
    inline: {
      options: ["bold", "italic", "underline"],
      bold: { icon: BoldIcon },
      italic: { icon: ItalicIcon },
      underline: { icon: UnderlineIcon },
    },
    list: {
      inDropdown: false,
      options: ["unordered"],
      unordered: { icon: unorderedList },
    },
  };

  const handleProduct = () => {
    setChangeComp("");
    const sectionIndex = sections?.findIndex(
      (item) => item?.sectionName === activeTab,
    );
    const subSectionParts =
      sections?.[sectionIndex]?.subSections?.[index]?.subSectionParts || [];
    const totalizeAmountInSectionHeader =
      sections?.[sectionIndex]?.subSections?.[index]
        ?.totalizeAmountInSectionHeader || 1;
    const total = sections?.[sectionIndex]?.subSections?.[index]?.total || 0;
    const data = {
      index,
      sectionIndex,
      subSectionParts,
      sections,
      totalizeAmountInSectionHeader,
      total,
      activeTab,
      quoteDetails,
    };
    dispatch(quoteProductState(data));
    history.push(`/quote/${quoteId}/product-and-service`);
  };

  useEffect(() => {
    if (localStorage.getItem("quoteBlockNavigation") === "yes") {
      setChangeComp("asc");
      console.log("asc345");
    }
  }, []);

  const handleChange = async (e, type) => {
    setChangeComp("asc");
    sections.forEach((section, ind) => {
      if (section?.sectionName === activeTab) {
        section?.subSections?.forEach((subSection, i) => {
          if (i === index) {
            if (type === "description") subSection.description = e;
            if (type === "title") subSection.title = e.target.value;
            if (type === "delete") {
              simpleRequest(
                `/api/quote/${quoteId}/section/${section?.sectionid}/subsection/${subSection?.subsectionid}`,
                "delete",
                {},
              );
            }
          }
        });
        if (type === "delete") section?.subSections?.splice(index, 1);
      }
    });
    setSections([...sections]);
  };

  function handleKeyDown(event) {
    return getDefaultKeyBinding(event);
  }

  const [suffix, setSuffix] = useState("");
  console.log("asc suffix", suffix);

  const handleChange2 = async (e, type, innerindex) => {
    setChangeComp("asc");
    sections.forEach((section, ind) => {
      if (section?.sectionName === activeTab) {
        section?.subSections?.forEach((subSection, i) => {
          if (i === index) {
            subSection.subSectionParts.forEach((item, index) => {
              if (innerindex === index) {
                if (type === "suffix") {
                  item.suffix = e.target.value;

                  // update suffix
                  const newValue = e.target.value;
                  const parts = newValue.trim().split(" ");
                  const lastWord = parts.slice(-2).join(" ") || "";
                  setSuffix(lastWord);
                }

                if (type === "qty") {
                  item.qty = e.target.value;
                  item.total = (+item.unitPrice || 0) * (+e.target.value || 0);

                  subSection.total = subSection.subSectionParts.reduce(
                    (sum, part) => sum + (+part.total || 0),
                    0,
                  );
                }
              }
            });
          }
        });
      }
    });
    setSections([...sections]);
  };

  return (
    <div
      className="quote-n-single-section frc"
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <div
        className="fc"
        style={{
          rowGap: "24px",
          marginTop: "18px",
          display: activeTab === "Term & Condition" ? "none" : "",
        }}
        {...provided.dragHandleProps}
      >
        <div className="drag-line-flex">
          <hr className="st-under" style={{ margin: "0" }} />
          <hr className="st-under" style={{ margin: "0" }} />
        </div>
        <Tooltip title="Delete" color={"red"}>
          <img
            src={bin}
            style={{ cursor: "pointer" }}
            alt=""
            width={17}
            height={18}
            onClick={(e) => handleChange(e, "delete")}
          />
        </Tooltip>
      </div>
      <div className="quote-n-single-section-main fc">
        <div
          className="quote-n-single-section-head frcb"
          style={{ columnGap: "1rem" }}
        >
          <input
            placeholder="Title here"
            className="quote-n-single-section-title-input"
            value={subSection?.title}
            onChange={(e) => handleChange(e, "title")}
          />
          {subSection?.totalizeAmountInSectionHeader === 1 && (
            <p
              className="quote-n-subSection-total"
              style={{
                display: activeTab === "Term & Condition" ? "none" : "",
              }}
            >
              {europeanFormatWithSymbol(subSection?.total)}
            </p>
          )}
        </div>
        <div>
          {subSectionParts?.length > 0 && (
            <div className="quote-n-subsection-prod-main-box fc">
              <div className="quote-n-subsection-prod-topbox">
                <p>Item Description</p>
                <p style={{ textAlign: "center" }}>Measure Unit</p>
                <p style={textEnd}>Unit Price</p>
                <p style={textEnd}>Qty.</p>
                <p style={textEnd}>Total</p>
              </div>
              <div className="quote-n-subsection-underline-dashed" />
              <div
                className="fc"
                style={{ rowGap: "0.5rem", padding: "0.5rem 1rem" }}
              >
                {subSectionParts?.map((part, i) => {
                  return (
                    <div className="quote-n-subsection-prod-single" key={i}>
                      <div
                        className="d-flex"
                        //  onClick={handleProduct}
                      >
                        <p>{part?.productPartName}</p>
                        <input
                          type="text"
                          style={{ border: "none" }}
                          value={part?.suffix}
                          onChange={(e) => handleChange2(e, "suffix", i)}
                        />
                      </div>

                      <p style={{ textAlign: "center" }}>{part?.measureUnit}</p>

                      <p style={textEnd}>
                        {europeanFormatWithSymbol(+part?.unitPrice)}
                      </p>

                      {/* <p style={textEnd}>{part?.qty}</p> */}
                      <input
                        type="number"
                        style={{ border: "none", textAlign: "end" }}
                        value={part?.qty ?? 0}
                        onChange={(e) => handleChange2(e, "qty", i)}
                      />

                      <p style={textEnd}>
                        {europeanFormatWithSymbol(+part?.total)}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div
            className={`quote-n-editor-div ${activeTab === "Term & Condition" ? "quote-editor-height" : ""}`}
          >
            <Editor
              // placeholder="Add text here"
              placeholder={t("Add text here")}
              editorState={subSection?.description}
              onEditorStateChange={(e) => handleChange(e, "description")}
              wrapperClassName="wrapper-class"
              editorClassName="write-message"
              toolbarClassName="toolbar-bottom-absolute"
              toolbar={toolbar}
              toolbarCustomButtons={[
                <AddProductComp
                  handleProduct={handleProduct}
                  FetchTranslationList={FetchTranslationList}
                  activeTab={activeTab}
                />,
              ]}
              keyBindingFn={handleKeyDown}
              FetchTranslationList={FetchTranslationList}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const AddProductComp = ({ handleProduct, FetchTranslationList, activeTab }) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <div
      className="quote-n-product-div"
      style={{ display: activeTab === "Term & Condition" ? "none" : "" }}
      onClick={handleProduct}
    >
      <div className="quote-n-add-prod-text">
        {/* Add a product or Service */}
        {t("Add a product or service")}
      </div>
      <div>
        <BsBoxSeam className="quote-n-add-product-box" />
      </div>
    </div>
  );
};

const PrintModal = ({
  showPrintModal,
  setShowPrintModal,
  setChangeComp,
  FetchTranslationList,
}) => {
  const history = useHistory();
  const { quoteId } = useParams();
  const [activeDrop, setActiveDrop] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTemplate, setActiveTemplate] = useState(0);
  const link = window.sessionStorage.getItem("quoteLink");
  const t = (key) => FetchTranslationList?.[key] || "";

  const style = {
    borderBottomLeftRadius: activeDrop ? "0" : "10px",
    borderBottomRightRadius: activeDrop ? "0" : "10px",
    backgroundColor: activeDrop ? "white" : "#f1f1f1",
    borderTop: activeDrop && "1px solid #707070",
    borderLeft: activeDrop && "1px solid #707070",
    borderRight: activeDrop && "1px solid #707070",
    transitionDuration: "300ms",
  };

  const handlePrint = () => {
    setChangeComp("");
    if (activeTab === 0) return history.push(`/quote/${quoteId}/pdf`);
    if (activeTab === 1) {
      const win = window.open(link, "_blank");
      win.focus();
    }
  };

  return (
    <Modal
      show={showPrintModal}
      onHide={() => setShowPrintModal(false)}
      centered
    >
      <div className="quote-print-modal">
        <div className="quote-print-modal-top-box frcb">
          <p className="quote-print-modal-headline">Print Options</p>
          <img
            width={20}
            height={20}
            src={close}
            style={{ cursor: "pointer" }}
            onClick={() => setShowPrintModal(false)}
          />
        </div>
        <div className="quote-print-modal-content-box fc">
          <div className="quote-print-modal-radio-line frc">
            <div
              className="quote-print-modal-radio-btn"
              style={{
                background:
                  activeTab === 0
                    ? "linear-gradient(179deg, #00246A, #95A7C6)"
                    : "white",
                border: activeTab === 0 ? "" : "0.5px solid #00000026",
              }}
              onClick={() => setActiveTab(0)}
            ></div>
            <p className="quote-print-modal-radio-text">Create PDF</p>
          </div>
          <div className="quote-print-modal-radio-line frc">
            <div
              className="quote-print-modal-radio-btn"
              style={{
                background:
                  activeTab === 1
                    ? "linear-gradient(179deg, #00246A, #95A7C6)"
                    : "white",
                border: activeTab === 1 ? "" : "0.5px solid #00000026",
              }}
              onClick={() => setActiveTab(1)}
            ></div>
            <p className="quote-print-modal-radio-text">
              {/* Create Online version */}
              {t("Create Online version")}
            </p>
          </div>
          <div className="quote-print-modal-radio-line frc">
            <div
              className="quote-print-modal-radio-btn"
              style={{
                background:
                  activeTab === 2
                    ? "linear-gradient(179deg, #00246A, #95A7C6)"
                    : "white",
                border: activeTab === 2 ? "" : "0.5px solid #00000026",
              }}
              onClick={() => setActiveTab(2)}
            ></div>
            <p className="quote-print-modal-radio-text">Print using template</p>
          </div>
          <div className="quote-print-modal-radio-line frc">
            <div
              className="quote-print-modal-radio-btn"
              style={{ opacity: 0 }}
            ></div>
            <div className="quote-modal-template-main-box">
              <div
                className="quote-modal-template-box-1 frcb"
                style={style}
                onClick={() => setActiveDrop(!activeDrop)}
              >
                <p>Another quote template name</p>
                <img src={arrow} />
              </div>
              {activeDrop && (
                <div className="quote-modal-templates-list fc">
                  <div className="quote-modal-single-template frcb">
                    <p>Default quote template name</p>
                    <IoMdCheckmark style={{ color: "#333333" }} />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className="frc"
            style={{ justifyContent: "center", marginTop: "1rem" }}
          >
            <button
              className="cal-page-change"
              style={{ backgroundColor: "#00246A" }}
              onClick={handlePrint}
            >
              {/* Print */}
              {t("Print")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuoteNew;
